import { getDateWithoutTimePart } from '@/helpers';
import currency from '@/helpers/currency';
import PIECE_TYPES from '../../models/pieceTypes';
import CURRENCIES from '../../models/currencies';
import ORDER_TYPES from '../../models/orderTypes';

const getters = {
  pickUpAddress(state) {
    const { locationFrom, locationTo } = state;
    if (!locationFrom) {
      return null;
    }

    const {
      CityAlias: cityFrom,
      autoPostal: autoPostalFrom,
      PostfixNeeded: postfixNeededFrom,
      Postfix: postfixFrom,
      CountryCode: countryCodeFrom,
      WindowsTimeZoneId: windowsTimeZoneId,
    } = locationFrom;

    let { PostalCode: postalCodeFrom } = locationFrom;
    if (postfixNeededFrom === 1) {
      postalCodeFrom += postfixFrom;
    }
    if (!postalCodeFrom) {
      postalCodeFrom = autoPostalFrom;
    }

    const {
      CityAlias: cityTo,
      autoPostal: autoPostalTo,
      PostfixNeeded: postfixNeededTo,
      Postfix: postfixTo,
      CountryCode: countryCodeTo,
    } = locationTo;

    let { PostalCode: postalCodeTo } = locationTo;
    if (postfixNeededTo === 1) {
      postalCodeTo += postfixTo;
    }
    if (!postalCodeTo) {
      postalCodeTo = autoPostalTo;
    }

    return {
      cityFrom,
      countryCodeFrom,
      postalCodeFrom,
      cityTo,
      countryCodeTo,
      postalCodeTo,
      windowsTimeZoneId,
    };
  },
  pieces(state) {
    return state.pieces.map((p, i) => {
      p.id = i;
      return p;
    });
  },
  canCalculate(state) {
    const { locationFrom, locationTo, pieces } = state;

    return !!(locationFrom && locationTo && pieces.length > 0);
  },

  isPointToPoint(state) {
    // если отправка из офиса
    const isWalkType = state.orderType === ORDER_TYPES.WALK_TYPE;
    // если servicePointFrom является отделением DHL (не сервис-деск) и имеет isAgency=true
    const { isAgency } = state.servicePointFrom || {};
    const isOrderPointToPoint = !!(
      state.selectedOrder && state.selectedOrder.point_to_point
    );

    return isOrderPointToPoint && !(isWalkType && isAgency);
  },
  productCurrency(state) {
    if (state.selectedProduct) {
      let result = state.selectedProduct.currency_code;
      const currencyCode = CURRENCIES.find(
        (c) => c.code === state.selectedProduct.currency_code,
      );
      const productCurrency = currencyCode || null;
      if (productCurrency) {
        result = productCurrency.displayName;
      }
      return result;
    }

    return '';
  },
  hasProduct(state) {
    return !!state.selectedProduct;
  },
  extras(state) {
    return state.selectedProduct && state.selectedProduct.extraCharges
      ? state.selectedProduct.extraCharges
      : [];
  },
  hasExtras(state, getter) {
    return getter.extras.length > 0;
  },
  orderCost(state) {
    const productCost = state.selectedProduct
      ? state.selectedProduct.shipping_charge
      : 0;

    const codes = state.selectedExtras.map((e) => e.code);
    const extrasCost = state.selectedExtras.reduce((a, extra) => {
      let result = extra.cost.value;
      const exceptions = [...extra.cost.exceptions];
      if (exceptions.length > 0) {
        if (codes.find((code) => exceptions.includes(code))) {
          result = 0;
        }
      }
      return a + result;
    }, 0);

    const dutyCost =
      state.isCustomsDuty && state.customDutyAmount
        ? state.customDutyAmount
        : 0;

    return currency.formatCurrency(productCost + extrasCost + dutyCost);
  },
  isServicePointIsAgency(state) {
    return state.servicePointFrom ? state.servicePointFrom.isAgency : false;
  },
  servicePointFrom(state) {
    return state.servicePointFrom;
  },
  isInternationalNonDoc(state, getter) {
    return getter.isNonDoc && getter.isInternational;
  },

  isNonDoc(state) {
    return state.pieces.some(
      (pieces) => pieces.type.type === PIECE_TYPES.NonDocuments,
    );
  },

  isInternational(state) {
    return (
      state.locationTo &&
      state.locationTo.CountryCode.toLocaleLowerCase() !== 'ru'
    );
  },

  paymentMethods(state) {
    if (state.selectedProduct) {
      const { paymentMethods } = state.selectedProduct;
      return paymentMethods;
    }
    return [];
  },
  hasPaymentMethods(state, getter) {
    return getter.paymentMethods.length > 0;
  },
  payment(state) {
    return state.selectedPayment;
  },
  customsDuty(state) {
    return state.selectedProduct && state.selectedProduct.customsDuty
      ? state.selectedProduct.customsDuty
      : [];
  },
  chargeXK(state) {
    if (state.selectedProduct && state.selectedProduct.extraCharges) {
      return (
        state.selectedProduct.extraCharges.find((e) => e.code === 'XK') || null
      );
    }

    return null;
  },
  isCustomsDuty(state) {
    return state.isCustomsDuty;
  },
  availableTimesRanges(state) {
    return state.pickUpAvailableTimes ? state.pickUpAvailableTimes.times : [];
  },
  serviceCallPhones(state) {
    return (
      state.calculateResult &&
      state.calculateResult.call &&
      state.calculateResult.call.phones
    );
  },
  filterWeekendDay: (state) => (date) => {
    const filteredObj = {};
    const validateDate = getDateWithoutTimePart(date);
    const validateDateTime = +validateDate.getTime();

    const { weekendRanges } = state.pickUpAvailableWeekend;
    const keysWeekendRanges = Object.keys(weekendRanges);
    // eslint-disable-next-line no-restricted-syntax
    for (const weekendDayTime of keysWeekendRanges) {
      if (+weekendDayTime === validateDateTime) {
        filteredObj[weekendDayTime] = weekendRanges[weekendDayTime];
      }
    }

    return filteredObj;
  },
  isSenderNotRu(state) {
    return (
      state.locationFrom &&
      state.locationFrom.CountryCode.toLocaleLowerCase() !== 'ru'
    );
  },
};

export default getters;
